import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button, Table, Spinner } from "react-bootstrap";

function actionLabelUk(action) {
    if (action === "create") {
        return "Створення";
    }
    if (action === "update") {
        return "Зміна";
    }
    if (action === "delete") {
        return "Видалення";
    }
    return action || "—";
}

export default function HubChangeLogModal({ show, onHide, scope, title }) {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const load = useCallback(async () => {
        if (!show) {
            return;
        }
        setLoading(true);
        try {
            const res = await axios.get("/api/hub-change-log", {
                params: { scope, limit: 80 },
            });
            setItems(Array.isArray(res.data?.items) ? res.data.items : []);
        } catch (e) {
            console.error(e);
            setItems([]);
        } finally {
            setLoading(false);
        }
    }, [show, scope]);

    useEffect(() => {
        void load();
    }, [load]);

    return (
        <Modal show={show} onHide={onHide} size="lg" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="d-flex justify-content-center py-4">
                        <Spinner animation="border" role="status" />
                    </div>
                ) : items.length === 0 ? (
                    <p className="text-muted mb-0">
                        Записів ще немає — журнал ведеться з моменту оновлення; нові зміни з’являться тут.
                    </p>
                ) : (
                    <Table striped size="sm" className="mb-0 align-top">
                        <thead className="table-light">
                            <tr>
                                <th className="text-nowrap">Коли</th>
                                <th className="text-nowrap">Хто</th>
                                <th className="text-nowrap">Дія</th>
                                <th>Об’єкт</th>
                                <th>Зміни</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((row) => (
                                <tr key={row.id}>
                                    <td className="text-nowrap small">
                                        {new Date(row.at).toLocaleString("uk-UA", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </td>
                                    <td className="small">{row.userDisplayName}</td>
                                    <td className="small text-nowrap">
                                        {actionLabelUk(row.action)}
                                    </td>
                                    <td className="small" style={{ maxWidth: 200 }}>
                                        {row.entityLabel}
                                    </td>
                                    <td className="small">
                                        {(row.lines || []).map((ln, i) => (
                                            <div key={i} className="text-break">
                                                {ln}
                                            </div>
                                        ))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Закрити
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
